var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-full bg-grey-400"},[_c('div',{staticClass:"text-xs leading-none pb-1 text-center text-white",style:({
                background: ("" + _vm.color),
                width: (_vm.strengthPercentage + "%"),
            })})]),_vm._v(" "),(_vm.isCommon)?_c('small',{class:_vm.errorTextClass},[_vm._v("\n        This is a very common password.\n    ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }